<script lang="ts">
    import { onMount } from 'svelte/internal'
    import DateSelectMonth from '../../_common/date-select-month.svelte'
    import Zframe from '../../_common/z/zframe.svelte'
    import Zact from '../../_common/z/zact.svelte'
    import Zinput from '../../_common/z/zinput.svelte'
    import Zgrid from '../../_common/z/zgrid.svelte'
    import LoadSpinner from '../../_common/load-spinner.svelte'
    import { GridClass } from '../../_common/z/zgrid'
    import { buildReportGrid } from '../_shared/build-report-grid'
    import { inferChartConfig, REPORT_VIEW_MODE_OPTIONS } from '../_shared/report-chart-defaults'
    import type { ReportViewMode } from '../_shared/report-chart-defaults'
    import ReportChartViewer from '../_shared/report-chart-viewer.svelte'
    import type { ReportCatalogItem, ReportResponse } from '../../../modules/reportsApi/catalog/report-catalog'
    import type { Category } from '../../../modules/financialApi/categories/category'

    export let report: ReportCatalogItem = undefined

    const ENDPOINT = '/reports/financial/entries-by-category-detail'

    let show = false
    let viewMode: ReportViewMode = window.store.reportViewMode
    let dateSelect: { from: Date; to: Date } = window.api.utils.dates.currentMonth()
    let response: ReportResponse = null
    let grid: GridClass = null
    let categoryOptions: { value: string; label: string }[] = []
    let categoryId: string = null

    $: chartConfig = response ? inferChartConfig(response) : null

    function viewModeChanged() {
        window.store.reportViewMode = viewMode
    }

    onMount(async () => {
        const categories: Category[] = await window.api.financials.categories.getAll({ removeds: true })
        categoryOptions = categories.map((el) => ({ value: el.categoryId, label: el.label })).sort((a, b) => a.label.localeCompare(b.label))
        if (categoryOptions.length) {
            categoryId = categoryOptions[0].value
            load()
        }
    })

    async function load() {
        if (show || !categoryId) return
        show = true
        try {
            response = await window.api.reports.catalog.run(report?.endpoint || ENDPOINT, {
                from: dateSelect.from,
                to: dateSelect.to,
                categoryId,
            })
            grid = buildReportGrid(response)
        } catch (error) {
            window.error(error)
        } finally {
            show = false
        }
    }

    function dateChanged(event) {
        dateSelect = event.detail
        load()
    }

    function categoryChanged() {
        load()
    }
</script>

<div class="relat-body">
    <Zframe title={response?.title || 'Detalhado por categoria'} headline={response?.notes}>
        <Zact class="h-print mb-3">
            <DateSelectMonth on:change={dateChanged} startFrom={dateSelect.from} startTo={dateSelect.to} />
            <Zinput skin="soft" type="select" label="Categoria" options={categoryOptions} bind:value={categoryId} on:change={categoryChanged} />
            {#if chartConfig}
                <div class="spacer" />
                <Zinput size={0} type="select" label="Exibição" options={REPORT_VIEW_MODE_OPTIONS} bind:value={viewMode} on:change={viewModeChanged} />
            {/if}
        </Zact>
        {#if chartConfig && (viewMode === 'chart' || viewMode === 'report-chart')}
            <div class="mb-3">
                <ReportChartViewer {response} dimensionKey={chartConfig.dimensionKey} valueKey={chartConfig.valueKey} type={chartConfig.type} />
            </div>
        {/if}
        {#if !chartConfig || viewMode === 'report' || viewMode === 'report-chart'}
            <Zgrid {grid} />
        {/if}
    </Zframe>
</div>
<LoadSpinner {show}></LoadSpinner>
